import { render, staticRenderFns } from "./StockInformationForOrder.vue?vue&type=template&id=3c75d61d&"
import script from "./StockInformationForOrder.vue?vue&type=script&lang=js&"
export * from "./StockInformationForOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports